let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eKr4d")).then(() => parcelRequire('6S4DZ'));